import {
  PlacementDragGhost,
  type PlacementDragGhostProps,
} from '@/components/app/placement/placement-drag-ghost'
import type { TemplateListItem } from '@/lib/templates/types/template-list-item'

type TemplateDragGhostProps = Omit<PlacementDragGhostProps, 'imageUrl' | 'label'> & {
  template: TemplateListItem
}

/** `PlacementDragGhost` for a template — see that file for the positioning and flyback logic. */
export function TemplateDragGhost({ template, ...ghostProps }: TemplateDragGhostProps) {
  return (
    <PlacementDragGhost
      imageUrl={template.urlSmallPreview}
      label={template.templateName}
      {...ghostProps}
    />
  )
}
